import React from 'react'
import { createPortal } from 'react-dom'
import { MdOutlineWarningAmber } from 'react-icons/md'
import styles from './Confirm.module.scss'
import { useI18n } from '../../i18n/I18nProvider'

const Confirm = ({
  confirm = 'Are you sure?',
  confirmBtnVariant = 'danger',
  confirmBtnLabel = 'Confirm',
  alertOnly = false,
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  const { t } = useI18n()

  return createPortal(
    <div className={styles.overlay} role="presentation">
      <button
        type="button"
        className={styles.backdrop}
        aria-label={t('Cancel')}
        tabIndex={-1}
        onClick={onCancel}
      />
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
      >
        <div className={styles.header}>
          <div className={styles.alertIcon}>
            <MdOutlineWarningAmber size={22} />
          </div>
          <h3 className={styles.title} id="confirm-title">
            {alertOnly ? t('Action not allowed') : t('Confirmation Required')}
          </h3>
          <p className={styles.message}>{confirm}</p>
        </div>
        <div className={styles.actions}>
          {alertOnly ? (
            <button
              type="button"
              onClick={onCancel}
              className={`${styles.confirmBtn} ${styles.okBtn}`}
            >
              {t(confirmBtnLabel)}
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={onCancel}
                className={styles.cancelBtn}
              >
                {t('Cancel')}
              </button>
              <button
                type="button"
                onClick={onConfirm}
                className={styles.confirmBtn}
              >
                {t(confirmBtnLabel)}
              </button>
            </>
          )}
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default Confirm
